import styles from './style.postcss';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import is from 'is_js';
import { testClass, Form, Grid } from 'omni-common-ui';
import { accessors as idpAccessors } from 'data/IndividualDevelopmentPlans';
import PropTypes from 'prop-types';
import SkillRecommendation from './SkillRecommendation';

export default class SkillSuggestionCard extends PureComponent {
  _judgeValue(boardValue) {
    if (! is.not.undefined(boardValue) || ! boardValue || boardValue === '') {
      return '–';
    }
    return boardValue;
  }

  _getSkillDescription(skillSuggestion, skillOptions) {
    if (! skillSuggestion) return '';
    const selectedOption =
      skillOptions.find((skillOption) => skillOption.skillId === skillSuggestion.skillId);
    return this._formatOptionLabel(selectedOption.name, selectedOption.score);
  }

  _formatOptionLabel(name, score) {
    return `${name} ${idpAccessors.formatSkillScore(score)}`;
  }

  _convertToSelectOptions(skillOptions) {
    const options = skillOptions
      .filter((skillOption) => is.not.inArray(skillOption.skillId, this.props.hiddenOptions))
      .map((skillOption) => {
        const optionValue = this._formatOptionLabel(skillOption.name, skillOption.score);
        return { label: optionValue, value: skillOption.skillId };
      });
    options.splice(0, 0, {
      label: ' ',
      value: 0,
      className: styles.SkillSuggestionCard_select_option,
    });
    return options;
  }

  _renderSkillResult() {
    const { skillSuggestion, skillOptions, onSkillChanged, index } = this.props;
    const classesH5 = classnames(styles.SkillSuggestionCard_h5, testClass('field-title'));
    if (this.props.isInEditMode &&
        this.props.isManuallyAdded &&
        is.not.empty(skillOptions)) {
      const options = this._convertToSelectOptions(skillOptions);
      const selectedValue = (skillSuggestion && skillSuggestion.skillId) || 0;
      return <Form className={styles.SkillSuggestionCard_skillResult}>
        <div className={styles.SkillSuggestionCard_skillResult_indexLabel}>
          {`Skill ${index + 1} (optional)`}
        </div>
        <Form.Select name="suggestion-skill"
            options={options}
            value={selectedValue}
            setValue={onSkillChanged}
            clearable={false}
            searchable={false} />
      </Form>;
    }
    return <h5 className={classesH5}>
      {this._getSkillDescription(skillSuggestion, skillOptions)}
    </h5>;
  }

  render() {
    const classesBoard = classnames(styles.SkillSuggestionCard_board);
    const { skillSuggestion, isMissing, canEditSkillRecommandation } = this.props;
    return <div className={classesBoard}>
      <Grid>
        <Grid.Group>
          <Grid.Item xs={12} sm={6} md={6} className={styles.SkillSuggestionCard_item}>
            {this._renderSkillResult()}
          </Grid.Item>
        </Grid.Group>
      </Grid>
      { skillSuggestion &&
        <SkillRecommendation skillRecommendations={this.props.skillRecommendations}
            skillId={skillSuggestion.skillId}
            isSSV3Group={this.props.isSSV3Group}
            isInEditMode={this.props.isInEditMode}
            selectedRecommendationItemIds={skillSuggestion.selectedRecommendationList}
            suggestion={this._judgeValue(skillSuggestion.suggestion)}
            onRecommendationChanged={this.props.onRecommendationChanged}
            isMissing={isMissing}
            showEditButton={canEditSkillRecommandation} />}
    </div>;
  }

}

SkillSuggestionCard.propTypes = {
  skillSuggestion: PropTypes.shape(),
  isSSV3Group: PropTypes.bool,
  isInEditMode: PropTypes.bool.isRequired,
  className: PropTypes.string,
  skillOptions: PropTypes.array,
  onSkillChanged: PropTypes.func,
  onRecommendationChanged: PropTypes.func,
  isManuallyAdded: PropTypes.bool.isRequired,
  isMissing: PropTypes.bool,
  canEditSkillRecommandation: PropTypes.bool,
  index: PropTypes.number.isRequired,
  hiddenOptions: PropTypes.array,
  skillRecommendations: PropTypes.shape(),
};



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/SkillSuggestionCard/index.jsx